





















































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Comment } from '@/api/model/comment'
import { User } from '@/api/model/user'

@Component
export default class Comments extends Vue {
    @Prop() readonly comments!: Comment[]
    @Prop({ default: () => []}) readonly mentionableUsers!: User[]
    @Prop({ type: Boolean, default: false }) canDelete!: boolean

    isOwnComment(comment: Comment): boolean {

        // Skip KeyVue user (= null)
        if (comment.user === null) {
            return false
        }

        return this.$currentUser.id === comment.user.id
    }

    renderComment(comment: string): string {
        this.mentionableUsers.forEach(user => {
            comment = comment.replaceAll(
                `@${user.name}`,
                `<span class="text-pink-500">${user.name}</span>`,
            )
        })

        return comment
    }

    async deleteComment(comment: Comment): Promise<void> {
        this.$emit('delete', comment)
    }

    get sortedComments() {
        return this.comments
            .filter(comment => comment instanceof Comment)
            .sort((a: Comment, b: Comment) => a.createdAt > b.createdAt ? -1 : 1)
    }
}
